import React, { useEffect, useState } from 'react'
import { CustomButton, InfosInputs, SimpleTitleCard } from 'styles/global'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import { maskCPF, maskMoney, maskNumber, removeMaskMoney } from 'util/masks'
import {
  Col,
  Collapse,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap'
import useRedux from 'hooks/useRedux'
import * as kanbanActions from 'store/modules/kanban/actions'
import InputCustom from 'components/Inputs'
import * as yup from 'yup'
import { toast } from 'react-toastify'
import { validaCpf } from 'util/validations'
import { BsPencilFill } from 'react-icons/bs'
import CustomSelect from 'components/Select'

const ModalCadastroCliente = () => {
  const { modalCadastroCliente, optionsSelect, loadingSelect, kanbanData } =
    useSelector<ApplicationState, KANBAN>((state) => state.kanban)

  const { dispatch } = useRedux()

  const [sessaoServidor, setSessaoServidor] = useState(false)
  const [hasMatricula, setHasMatricula] = useState(false)

  type Fields = KANBAN['modalCadastroCliente']['register']
  function onChange<T extends keyof Fields>(value: Fields[T], field: T) {
    if (value) {
      if (field === 'perfilId') {
        const perfil = optionsSelect.perfis.find(
          (perfil) => perfil.id === value
        )
        if (!perfil?.descricao.toUpperCase().includes('SERVIDOR')) {
          return dispatch(
            kanbanActions.setRegisterModalCadastroCliente({
              ...modalCadastroCliente.register,
              margem: '',
              margemCartao: '',
              convenioId: '',
              perfilId: String(value)
            })
          )
        }
      }
      if (field === 'cpf' && maskCPF(String(value)).length === 14) {
        // dispatch(kanbanActions.getInformacoesSimplificadasSaga(value))
      }
      return dispatch(
        kanbanActions.setRegisterModalCadastroClienteField(value, field)
      )
    }
  }

  function toggleModal() {
    dispatch(kanbanActions.setIsOpenModalCadastroCliente(false))
    dispatch(kanbanActions.cleanInvalidsRegisterModalCadastroCliente())
    dispatch(kanbanActions.cleanRegisterModalCadastroCliente())
  }

  useEffect(() => {
    if (modalCadastroCliente.isOpen) {
      dispatch(kanbanActions.getConveniosSaga())
      dispatch(kanbanActions.getPerfisSaga())
    }
  }, [dispatch, modalCadastroCliente.isOpen])

  useEffect(() => {
    const perfilSelecionado = optionsSelect.perfis.find(
      (perfil) => perfil.id === modalCadastroCliente.register.perfilId
    )
    setSessaoServidor(
      perfilSelecionado?.descricao.toUpperCase().includes('SERVIDOR') || false
    )
    if (
      !perfilSelecionado?.descricao.toUpperCase().includes('SERVIDOR') &&
      !perfilSelecionado?.descricao.toUpperCase().includes('INSS')
    ) {
      setHasMatricula(true)
      dispatch(
        kanbanActions.setRegisterModalCadastroClienteField('', 'matricula')
      )
    } else {
      setHasMatricula(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalCadastroCliente.register.perfilId, optionsSelect.perfis])

  useEffect(() => {
    if (
      maskCPF(modalCadastroCliente.register.cpf).length === 14 &&
      modalCadastroCliente.isOpen
    ) {
      // dispatch(kanbanActions.getInformacoesSimplificadasSaga(cpfAtendimento))
    }
  }, [dispatch, modalCadastroCliente.register.cpf, modalCadastroCliente.isOpen])

  const schema = yup.object().shape({
    pipelineId: yup.string().required(),
    convenioId: yup
      .string()
      .when('sessaoServidor', {
        is: true,
        then: (schema) => schema.required()
      })
      .nullable(),
    cpf: yup
      .string()
      .test('test-invalid-cpf', 'cpf inválido', (cpf) => validaCpf(cpf || ''))
      .required(),
    dataNascimento: yup.string().required(),
    ddd: yup.string().required().min(2).max(3),
    margem: yup
      .number()
      .when('sessaoServidor', {
        is: true,
        then: (schema) => schema.required().moreThan(0).lessThan(1000000000.0)
      })
      .nullable(),
    margemCartao: yup
      .number()
      .when('sessaoServidor', {
        is: true,
        then: (schema) => schema.required().moreThan(0).lessThan(1000000000.0)
      })
      .nullable(),
    matricula: yup
      .string()
      .when('perfilId', {
        is: (perfilId: string) => {
          const perfisSemMatricula = optionsSelect.perfis.filter(
            (perfil) =>
              !perfil.descricao.includes('SERVIDOR') &&
              !perfil.descricao.includes('INSS')
          )
          return !perfisSemMatricula.some((perfil) => perfil.id === perfilId)
        },
        then: (schema) => schema.required()
      })
      .nullable(),
    nome: yup.string().required().min(3).max(100),
    perfilId: yup.string().required(),
    telefone: yup.string().required().min(8).max(9),
    sessaoServidor: yup.boolean().required(),
    numeroNit: yup
      .number()
      .nullable()
      .when('perfilId', {
        is: (perfilId: string) => {
          const perfilBolsaFamilia = optionsSelect.perfis.filter((perfil) =>
            perfil.descricao.includes('BOLSA FAMILIA')
          )
          return perfilBolsaFamilia.some((perfil) => perfil.id === perfilId)
        },
        then: (schema) => schema.required().min(1).max(99999999999),
        otherwise: (schema) => schema.nullable()
      })
  })

  function onSave() {
    dispatch(kanbanActions.cleanInvalidsRegisterModalCadastroCliente())
    schema
      .validate(
        {
          pipelineId: kanbanData.pipelineId,
          convenioId: modalCadastroCliente.register.convenioId,
          cpf: modalCadastroCliente.register.cpf,
          dataNascimento: modalCadastroCliente.register.dataNascimento,
          ddd: modalCadastroCliente.register.ddd,
          margem: Number(removeMaskMoney(modalCadastroCliente.register.margem)),
          margemCartao: Number(
            removeMaskMoney(modalCadastroCliente.register.margemCartao)
          ),
          matricula: modalCadastroCliente.register.matricula,
          nome: modalCadastroCliente.register.nome,
          perfilId: modalCadastroCliente.register.perfilId,
          telefone: modalCadastroCliente.register.telefone,
          sessaoServidor: sessaoServidor,
          numeroNit: Number(
            removeMaskMoney(modalCadastroCliente.register.numeroNit)
          )
        },
        { abortEarly: false }
      )
      .then(() => {
        dispatch(kanbanActions.cadastrarClienteSaga())
      })
      .catch((err) => {
        err.inner.forEach((e: yup.ValidationError) => {
          dispatch(
            kanbanActions.setInvalidsRegisterModalCadastroClienteField(
              {
                invalid: true,
                message: e.message
              },
              e.path as keyof KANBAN['modalCadastroCliente']['invalids']
            )
          )
        })
        toast.warn('Preencha todos os campos corretamente para salvar!')
      })
  }

  return (
    <Modal
      size="xl"
      isOpen={modalCadastroCliente.isOpen}
      toggle={() => toggleModal()}
    >
      <ModalBody>
        <ModalHeader toggle={() => toggleModal()}>
          <SimpleTitleCard>
            <BsPencilFill className="icon" />
            Cadastro simplificado cliente
          </SimpleTitleCard>
        </ModalHeader>
        <Row className="d-flex my-4 row-gap-15">
          <Col md={6}>
            <label className="label-12">Nome completo*</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(e.target.value, 'nome')
              }}
              value={modalCadastroCliente.register.nome}
              invalid={modalCadastroCliente.invalids.nome.invalid}
              maxLength={100}
            />
          </Col>
          <Col md={6}>
            <label className="label-12">CPF*</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskCPF(e.target.value), 'cpf')
              }}
              value={modalCadastroCliente.register.cpf}
              invalid={modalCadastroCliente.invalids.cpf.invalid}
              maxLength={14}
              disabled
            />
          </Col>
          <Col md={3}>
            <label className="label-12">DDD*</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskNumber(e.target.value), 'ddd')
              }}
              value={modalCadastroCliente.register.ddd}
              invalid={modalCadastroCliente.invalids.ddd.invalid}
              maxLength={3}
            />
          </Col>
          <Col md={9}>
            <label className="label-12">Telefone*</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskNumber(e.target.value), 'telefone')
              }}
              value={modalCadastroCliente.register.telefone}
              invalid={modalCadastroCliente.invalids.telefone.invalid}
              maxLength={9}
            />
          </Col>
          <Col md={4}>
            <label className="label-12">Data nascimento*</label>
            <InputCustom
              type="date"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(e.target.value, 'dataNascimento')
              }}
              value={modalCadastroCliente.register.dataNascimento}
              invalid={modalCadastroCliente.invalids.dataNascimento.invalid}
              maxLength={15}
            />
          </Col>
          <Col md={4}>
            <label className="label-12">Perfil*</label>
            <CustomSelect
              options={optionsSelect.perfis}
              placeholder="Selecione"
              onChange={(e) => {
                onChange(e, 'perfilId')
              }}
              value={modalCadastroCliente.register.perfilId}
              isLoading={loadingSelect.perfis}
              accessorLabel="descricao"
              accessorValue="id"
              invalid={modalCadastroCliente.invalids.perfilId.invalid}
            />
          </Col>
          {modalCadastroCliente.register.perfilId ===
            '86c60f5c-7875-4330-ae9c-c3e27de55850' && (
            <Col md={4}>
              <label className="label-12">Numero Nit*</label>
              <InputCustom
                type="text"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(maskNumber(e.target.value), 'numeroNit')
                }}
                value={modalCadastroCliente.register.numeroNit}
                invalid={modalCadastroCliente.invalids.numeroNit.invalid}
                maxLength={11}
              />
              <InfosInputs>Obrigatório se for bolsa família</InfosInputs>
            </Col>
          )}
          <Col md={4}>
            <label className="label-12">Matrícula</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskNumber(e.target.value), 'matricula')
              }}
              value={modalCadastroCliente.register.matricula}
              invalid={modalCadastroCliente.invalids.matricula.invalid}
              maxLength={15}
              disabled={hasMatricula}
            />
            <InfosInputs>Obrigatório se for Servidor ou Inss</InfosInputs>
          </Col>
          <Collapse isOpen={sessaoServidor}>
            <Row>
              <Col md={4}>
                <label className="label-12">Convênio*</label>
                <CustomSelect
                  options={optionsSelect.convenios}
                  placeholder="Selecione"
                  onChange={(e) => {
                    onChange(e, 'convenioId')
                  }}
                  value={modalCadastroCliente.register.convenioId}
                  isLoading={loadingSelect.convenios}
                  accessorLabel="descricao"
                  accessorValue="id"
                  invalid={modalCadastroCliente.invalids?.convenioId?.invalid}
                />
              </Col>
              <Col md={4}>
                <label className="label-12">Margem*</label>
                <InputCustom
                  type="text"
                  placeholder="Digite aqui"
                  onChange={(e) => {
                    onChange(maskMoney(e.target.value), 'margem')
                  }}
                  value={modalCadastroCliente.register.margem}
                  invalid={modalCadastroCliente.invalids?.margem?.invalid}
                  maxLength={14}
                />
              </Col>
              <Col md={4}>
                <label className="label-12">Margem Cartão*</label>
                <InputCustom
                  type="text"
                  placeholder="Digite aqui"
                  onChange={(e) => {
                    onChange(maskMoney(e.target.value), 'margemCartao')
                  }}
                  value={modalCadastroCliente.register.margemCartao}
                  invalid={modalCadastroCliente.invalids?.margemCartao?.invalid}
                  maxLength={14}
                />
              </Col>
            </Row>
          </Collapse>
        </Row>
        <ModalFooter>
          <Row className="d-flex justify-content-end column-gap-20">
            <CustomButton onClick={() => toggleModal()} background="#662D91">
              Voltar
            </CustomButton>
            <CustomButton onClick={() => onSave()}>Salvar</CustomButton>
          </Row>
        </ModalFooter>
      </ModalBody>
    </Modal>
  )
}

export default ModalCadastroCliente
